import { FlexCol } from "@quarks";
import styled from "styled-components";

export const StyledBottomContainer = styled(FlexCol)`
  border-top: 1px solid ${({ theme }) => theme.divider.grey};
  padding: 0 20px 24px 20px;
`;
